import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, ChevronLeft, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HpPalaceWalk() {
  const [walk, setWalk] = useState(null);
  const [idx, setIdx] = useState(0);
  const [recall, setRecall] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/hp-daily/palace-walk`, {}, { withCredentials: true, timeout: 90000 });
      setWalk(data); setIdx(0); setRecall(false); setRevealed(false);
      if (data.created_palace) toast.success('🏛️ Hampus byggde ett startpalats åt dig: "Mitt hem"');
    } catch { toast.error('Kunde inte starta promenaden 🐹'); }
    setBusy(false);
  };
  const go = (d) => { setIdx((i) => Math.max(0, Math.min(walk.stops.length - 1, i + d))); setRevealed(false); };

  if (!walk) {
    return (
      <button onClick={start} disabled={busy} className="neo-btn px-4 py-2 bg-[#A2D2FF] font-bold text-sm flex items-center gap-1" data-testid="hp-palace-walk-start">
        {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Hampus bygger knasiga bilder…</> : '🏛️ Palatspromenad med orden'}
      </button>
    );
  }
  const s = walk.stops[idx];
  const last = idx === walk.stops.length - 1;

  return (
    <section className="neo-card p-4 bg-gradient-to-br from-[#E8F0FF] to-[#FFE8F5] space-y-3" data-testid="hp-palace-walk">
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-[10px] font-bold tracking-[0.2em] uppercase opacity-60">
            {recall ? 'Minnestest' : 'Palatspromenad'} · {walk.palace.name} · {walk.source === 'today' ? 'dagens ORD-ord' : 'slumpat ordpaket'}
          </p>
          <h4 className="font-['Fredoka'] font-bold text-lg">📍 {s.location} <span className="text-xs opacity-50">({idx + 1}/{walk.stops.length})</span></h4>
        </div>
        <button onClick={() => setWalk(null)} className="text-xs underline opacity-60" data-testid="hp-palace-walk-close">Stäng</button>
      </div>
      {recall && !revealed ? (
        <button onClick={() => setRevealed(true)} className="w-full rounded-2xl border-2 border-dashed border-black/30 py-6 text-sm font-bold bg-white/70" data-testid="hp-palace-reveal">
          Vilket ord bor här? Tänk efter, klicka sen för att se 🐹
        </button>
      ) : (
        <div className="bg-white rounded-2xl p-3 border-2 border-black/10" data-testid="hp-palace-stop">
          <div className="font-['Fredoka'] text-2xl font-bold text-[#D06892]" data-testid="hp-palace-word">{s.word}</div>
          <div className="text-sm opacity-70">= {s.meaning}</div>
          <p className="text-sm italic mt-2 bg-[#FFF8E1] rounded-xl p-2">💡 {s.scene}</p>
        </div>
      )}
      <div className="flex items-center gap-2">
        <button onClick={() => go(-1)} disabled={idx === 0} className="neo-btn p-2 bg-white disabled:opacity-40" data-testid="hp-palace-prev"><ChevronLeft className="w-4 h-4" /></button>
        {!last && <button onClick={() => go(1)} className="neo-btn px-4 py-2 bg-white font-bold text-sm flex items-center gap-1" data-testid="hp-palace-next">Nästa plats <ChevronRight className="w-4 h-4" /></button>}
        {last && !recall && (
          <button onClick={() => { setRecall(true); setIdx(0); setRevealed(false); }} className="neo-btn px-4 py-2 bg-[#B9FBC0] font-bold text-sm" data-testid="hp-palace-recall">
            🧠 Gå promenaden igen och testa dig
          </button>
        )}
        {last && recall && <span className="text-sm font-bold" data-testid="hp-palace-done">Snyggt! Orden bor nu i ditt palats 💛</span>}
      </div>
    </section>
  );
}
